import React from 'react'
import Popular from '../Components/Popular/Popular'


const Shopcategory = () => {
  return (
    <div>
      <Popular/>

    </div>
  )
}

export default Shopcategory
